export default{
    //比较两个对象是否相等
    CompareTwoJson(objA,objB){
        objA=JSON.stringify(objA);
        objB=JSON.stringify(objB);
        if(objA === objB)
            return true;
        else
            return false;
    },
    
}


// WEBPACK FOOTER //
// ./src/util/lbtools.js